import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Box,
  Typography,
} from '@mui/material';
import {useCallback} from 'react';
import {IStation} from '../../../../../dto/Station.dto';
import CustomizedSwitches from '../../../../../components/styles/ToggleButton';
import {apiPut} from '../../../../../axiosConfig';
import {companyIdSelector} from '../../../../../store/Slices/companySlice';
import {useStoreSelector} from '../../../../../store/configstore';
import Toast from '../../../../../package/Toaster';
import {useQueryClient} from '@tanstack/react-query';

export const StationUpdate = ({
  parent_id,
  fullStations,
  setSelectedStation,
}: {
  parent_id: number | null;
  fullStations: IStation[];
  setSelectedStation: React.Dispatch<React.SetStateAction<IStation | null>>;
}) => {
  const handleChange = useCallback(
    (e: SelectChangeEvent) => {
      const parentId = Number(e.target.value);
      setSelectedStation(prev => {
        return {...prev, parent_id: parentId} as IStation;
      });
    },
    [setSelectedStation],
  );

  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      <Typography>Mirrored station</Typography>
      <FormControl sx={{width: 200}}>
        <InputLabel id='full-station-list-label'>Full station</InputLabel>
        <Select
          labelId='full-station-list-label'
          id='full-station-list'
          value={`${parent_id}`}
          label='Full station'
          size='small'
          onChange={handleChange}>
          {fullStations.map(station => {
            if (station.type === 'full_station') {
              return (
                <MenuItem value={station.id} key={station.id}>
                  {station.name}
                </MenuItem>
              );
            }
            return null;
          })}
        </Select>
      </FormControl>
    </Stack>
  );
};

export const PlayerUpdate = ({
  player_update_disabled,
  setSelectedStation,
  stationId,
}: {
  player_update_disabled: boolean;
  setSelectedStation: React.Dispatch<React.SetStateAction<IStation | null>>;
  stationId: number;
}) => {
  const companyId = useStoreSelector(companyIdSelector);
  const queryClient = useQueryClient();
  const handleChange = useCallback(
    (_e: React.SyntheticEvent<Element, Event>, checked: boolean) => {
      apiPut(`/v1/company/${companyId}/station/${stationId}`, {
        player_update_disabled_at: !checked ? `${Date.now()}` : null,
      }).then(() => {
        setSelectedStation(prev => {
          if (!checked) {
            return {
              ...prev,
              player_update_disabled_at: `${Date.now()}`,
            } as IStation;
          }
          return {...prev, player_update_disabled_at: null} as IStation;
        });
        queryClient.invalidateQueries({
          queryKey: ['api/v1/company', Number(companyId), 'stations'],
          refetchType: 'active',
        });
        Toast(`Player update ${checked ? 'enabled' : 'disabled'}`, 'success');
      });
    },
    [setSelectedStation, companyId, stationId, queryClient],
  );

  return (
    <Box className='flex items-center'>
      <CustomizedSwitches
        isActive={!player_update_disabled}
        onChange={handleChange}
      />
      <Typography>
        {player_update_disabled
          ? 'Player update is disabled'
          : 'Player update is enabled'}
      </Typography>
    </Box>
  );
};
